/**
 * Enumeration used to render links in listable elements
 * None: Don't render the link as a link, but as plain text
 * Link: Render the link as a simple link
 * ExternalLink: Render the link as a link that opens in a new tab
 */
export enum CollectionElementLinkType {
  None, Link, ExternalLink
}
